import React, { forwardRef, useMemo } from 'react';
import { Box } from '@mui/material';
import { PageRenderContext } from './pagerendercontext';

type PageRenderProps = {
  children: React.ReactNode;
  paginaID?: string;
  registro?: any
};

const PageRender = forwardRef<HTMLDivElement, PageRenderProps>(({ children, paginaID, registro }, ref) => {
  const contextValue = useMemo(() => ({ paginaID, registro }), [paginaID, registro]);

  return (
    <PageRenderContext.Provider value={contextValue}>
      <Box
      key={paginaID}
      id={paginaID}
        ref={ref}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flexGrow: { xs: "auto", md: 1},
          overflow: 'hidden',
          position: 'relative',
        }}
      >

        {children}
      </Box>
    </PageRenderContext.Provider>
  );
});

PageRender.displayName = 'PageRender';

export default PageRender;
